import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useCommunitiesClapsFeature = (): boolean => {
  const { company } = useCurrentSession()
  const { loading: newPackagingLoading, featureAvailability } =
    useFeatureAvailability('communities_claps')

  const { data: featureFlagsData, loading: legacyFlagsLoading } = useQuery(
    FeatureFlagAvailabilitiesDocument,
    {
      variables: {
        companyId: company.id,
        featureNames: ['dev_packaging_paywalls', 'dev_communities_kudos'],
      },
    }
  )

  const isLoading = newPackagingLoading || legacyFlagsLoading

  if (isLoading || !featureFlagsData) {
    return false
  }

  const features = featureFlagsData.features?.featuresConnection?.nodes ?? []
  const hasNewPackaging =
    features.find((f) => f.name === 'dev_packaging_paywalls')?.enabled ?? false

  // If the company is using the new packaging system, use GraphQL feature availability
  if (hasNewPackaging) {
    return featureAvailability.available
  }

  // Fallback to legacy feature flag for companies not on the new packaging system
  const hasLegacyFlag = features.find((f) => f.name === 'dev_communities_kudos')?.enabled ?? false
  return hasLegacyFlag
}
